import React from "react";
import { connect } from "react-redux";
import { compose } from "redux";

import * as setupReducer from "containers/Setup/reducer";
import { getStep } from "containers/CreateWizard/reducer";

import ChooseProcessLimit from "components/CreateWizard/Constraints/ChooseProcessLimit";
import ChooseProcessLimitMini from "components/CreateWizard/Constraints/ChooseProcessLimitMini";

class ChoooseProcessLimitContainer extends React.PureComponent {
  render() {
    const { isMini, step, index } = this.props;

    return isMini ? <ChooseProcessLimitMini {...this.props} /> : <ChooseProcessLimit {...this.props} />;
  }
}

const mapDispatchToProps = (dispatch, ownProps) => ({
  updateProcessLimit: (processLimit) => dispatch(setupReducer.updateProcessLimit(ownProps.id, processLimit, true)),
  updateTimePeriod: (timePeriod) => dispatch(setupReducer.updateTimePeriod(ownProps.id, timePeriod))
});

const mapStateToProps = (state, ownProps) => ({
  total: setupReducer.getTotal(state, ownProps.id),
  trueAction: setupReducer.getTrueAction(state, ownProps.id),
  processLimit: setupReducer.getProcessLimitCount(state, ownProps.id),
  processLimitPct: setupReducer.getProcessLimitPct(state, ownProps.id),
  targeted: setupReducer.getTargeted(state, ownProps.id),
  timePeriod: setupReducer.getTimePeriod(state, ownProps.id),

  step: getStep(state)
});

const withConnect = connect(mapStateToProps, mapDispatchToProps);

export default compose(withConnect)(ChoooseProcessLimitContainer);
